/* esm.sh - nostr-tools@2.23.3/nip42 */
var n=22242;function a(t,e){return{kind:n,created_at:Math.floor(Date.now()/1e3),tags:[["relay",t],["challenge",e]],content:""}}export{a as makeAuthEvent};
//# sourceMappingURL=nip42.mjs.map